import React from 'react';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '../../components/ui/dialog';

export const InhaberAddEmployeeDialog = ({ open, onOpenChange, value, onChange, onSubmit }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="bg-gray-900 border-gray-800">
      <DialogHeader>
        <DialogTitle className="text-white">Mitarbeiter hinzufügen</DialogTitle>
        <DialogDescription>Legen Sie einen neuen Mitarbeiter an</DialogDescription>
      </DialogHeader>
      <div className="space-y-4">
        <div>
          <label className="text-sm text-gray-400">Name</label>
          <Input
            value={value.name}
            onChange={(e) => onChange({ ...value, name: e.target.value })}
            className="bg-black/50 border-gray-700 text-white"
            placeholder="Max Mustermann"
            data-testid="add-employee-name"
          />
        </div>
        <div>
          <label className="text-sm text-gray-400">E-Mail</label>
          <Input
            type="email"
            value={value.email}
            onChange={(e) => onChange({ ...value, email: e.target.value })}
            className="bg-black/50 border-gray-700 text-white"
            placeholder="mitarbeiter@firma.de"
            data-testid="add-employee-email"
          />
        </div>
      </div>
      <DialogFooter>
        <Button variant="outline" className="border-gray-600 bg-transparent text-gray-200 hover:bg-gray-800 hover:text-white" onClick={() => onOpenChange(false)} data-testid="add-employee-cancel-btn">Abbrechen</Button>
        <Button onClick={onSubmit} className="bg-yellow-500 text-black" data-testid="add-employee-submit">
          Hinzufügen
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
